export default "__VITE_ASSET__DXaHscTE__"